import styled from '@emotion/styled'

export default styled.aside`
  text-align: left;
  line-height: 1.7;
  background-color: #ebf3ff;
  padding: 9px 18px;
  border-radius: 9px;
  border: solid #b2bdce 2px;
`
